export default __webpack_public_path__ + "static/zec-02f0410b6138161e9a650dd2ccd15d4b.jpeg";